const a = {
  "@ado/acs-standard-library": {
    "loading-bar": {
      "loading-message": () => "Preparando todo"
    },
    "contact-list": {
      "name-label": () => "Nombre",
      "email-label": () => "Email"
    },
    "contact-validator": {
      "duplicate-contact-message": () => "Contacto ya añadido",
      "maximum-recipients-message": () => "Se ha alcanzado el número máximo de invitaciones",
      "invalid-email-message": () => "Por favor, introduza una dirección de correo electrónico válida",
      "invalid-name-message": () => "Debe introducir un nombre"
    },
    "invitation-dialog": {
      "send-invite": () => "Enviar Invitación"
    }
  }
};
export {
  a as default
};
//# sourceMappingURL=index.js.map
